export default __webpack_public_path__ + "static/media/1.6d9749e7.png";